export default __webpack_public_path__ + "static/media/SUPERVISION.50744e7e.jpg";